import { useTranslation } from 'react-i18next'

import { SummaryLine } from '../../../../../types/booking/booking'
import { toDisplayOnlyDate } from '../../../../../utils/dateUtils'
import { formatMinutes, formatMoney, timeOf } from '../../../../../utils/booking/booking'

type SummarySlotRowProps = {
  line: SummaryLine
  showPrices: boolean
}

export const SummarySlotRow = ({ line, showPrices }: SummarySlotRowProps) => {
  const { t, i18n } = useTranslation('bookings')
  const prepaid = line.prepaidMinutes >= line.durationMinutes && line.durationMinutes > 0

  return (
    <div className="sum-row">
      <div>
        <div className="what">{line.courtName}</div>
        <div className="when">
          {t('booking.booking-courts.summary-panel.slot-details', {
            date: toDisplayOnlyDate(line.startTime, i18n.language),
            time: timeOf(line.startTime),
            durMin: formatMinutes(line.durationMinutes),
          })}
        </div>
      </div>

      {(showPrices || prepaid) && (
        <div className={`price-label ${prepaid ? 'included' : 'paid'}`}>
          {prepaid
            ? t('booking.booking-courts.summary-panel.plan')
            : line.amount
              ? formatMoney(line.amount)
              : '—'}
        </div>
      )}
    </div>
  )
}
